// extracted by mini-css-extract-plugin
module.exports = {"liked":"Heart_liked__1lGnH"};